import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permission.service';
import { ConfirmationService } from '../shared/services/confirmation.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private permissionService: PermissionService,
    private confirmationService: ConfirmationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      // Verificar acesso por grupos (módulos)
      const requiredGroups = route.data['requiredGroups'] as number[] | undefined;
      if (requiredGroups && requiredGroups.length > 0) {
        if (!this.permissionService.hasAnyGroup(requiredGroups)) {
          this.showAccessDenied();
          return false;
        }
      }

      // Verificar acesso por permissões individuais (qualquer uma basta por padrão)
      const requiredPermissions = route.data['requiredPermissions'] as string[] | undefined;
      const permissionMode = (route.data['permissionMode'] as 'any' | 'all') ?? 'any';
      if (requiredPermissions && requiredPermissions.length > 0) {
        const hasAccess =
          permissionMode === 'all'
            ? this.permissionService.hasAllPermissions(requiredPermissions)
            : this.permissionService.hasAnyPermission(requiredPermissions);
        if (!hasAccess) {
          this.showAccessDenied();
          return false;
        }
      }

      return true;
    }

    // Token inválido ou expirado, fazer logout e redirecionar para login
    this.authService.logout();
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  private showAccessDenied(): void {
    this.router.navigate(['/dashboard']);
    this.confirmationService.confirm({
      title: 'Acesso Negado',
      message: 'Você não possui permissão para acessar esta página. Entre em contato com o administrador caso precise de acesso.',
      type: 'warning',
      confirmText: 'Entendi',
      confirmButtonClass: 'btn-warning',
      hideCancelButton: true
    });
  }
}
